import { render, staticRenderFns } from "./relatedlink.vue?vue&type=template&id=35292e78&"
import script from "./relatedlink.vue?vue&type=script&lang=js&"
export * from "./relatedlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports